/* eslint-disable angular/controller-as */
(function (angular) {
    'use strict';

    angular
        .module('app.support')
        .controller('app.support.supportController', [
            'util',
            'supportService',
            '$scope',
            '$rootScope',
            '$location',
            '$cookies',
            supportController
        ]);

    function supportController(util, supportService, $scope, $rootScope, $location, $cookies) {
        $scope.siteContent = siteContent;
        $scope.selectedState = null;
        $scope.content = siteContent.site.pages.support;
        $scope.newFeeScheduleUrl = null;
        $scope.oldFeeScheduleUrl = null;
        $scope.dsdUrl = null;
        $scope.laUrl = null;
        $scope.oldDsdUrl = null;
        $scope.stateFeeScheduleUrl = null;
        $scope.stateDsdUrl = null;
        $scope.stateDsdText = null;
        $scope.stateFeeScheduleText = null;
        $scope.oldStateFeeScheduleUrl = null;
        $scope.oldStateFeeScheduleText = null;
        $scope.oldStateDsdUrl = null;
        $scope.oldStateDsdText = null;
        $scope.showStateSpecificFS = false;
        $scope.showStateSpecificMA = false;
        $scope.showOldStateSpecificFS = false;
        $scope.showOldStateSpecificMA = false;
        $scope.treatmentApiUrl = environment.treatmentApiDirectUrl;
        $scope.states = supportService.getStates();
        $scope.states = $scope.states.filter(function (s) {
            return $rootScope.supportedStates.indexOf(s.abbr) >= 0 && util.isStateIncluded(s);
        });
        $scope.goToGrivanceForm = goToGrivanceForm;
        $scope.onStateSelected = updateDocumentLinks;
        $scope.openLAGrienvencesLink = openLAGrienvencesLink;
        $scope.openLink = openLink;
        $scope.isCareingtonState = false;

        if ($rootScope.supportedStates.length <= 1) {
            updateDocumentLinks($scope.states[0]);
        }

        if (!siteContent.site.pages.support.sections.stateSelection.show) {
            if (
                $scope.content.sections.agreements.links.dsdLink &&
                $scope.content.sections.agreements.links.dsdLink != ''
            ) {
                $scope.dsdUrl = eval($scope.content.sections.agreements.links.dsdLink.link);
            }

            if (
                $scope.content.sections.agreements.links.pfsLink.link &&
                $scope.content.sections.agreements.links.pfsLink.link != ''
            ) {
                $scope.newFeeScheduleUrl = eval($scope.content.sections.agreements.links.pfsLink.link);
            }
        }

        if ($cookies.get('stateValue')) {
            var stateValueCookie = $cookies.get('stateValue');
            var stateObject = $scope.states.find(function (state) {
                return state.value === stateValueCookie;
            });

            if (stateObject) {
                updateDocumentLinks(stateObject);
            } else return;
        }

        $scope.$watch('states', function (newVal, oldVal) {
            if (newVal && stateValueCookie) {
                $scope.selectedState = $scope.states.find(function (state) {
                    return state.value === stateValueCookie;
                });
            }
        });

        function goToGrivanceForm() {
            if (!siteContent.site.pages.support.sections.stateSelection.show) {
                $location.url(siteContent.site.pages.support.sections.agreements.links.gfLink.link.replace('/#', ''));
            } else {
                if (
                    $rootScope.supportedStates.length <= 1 ||
                    (!$scope.selectStateForm.$invalid && $scope.selectStateForm.$dirty)
                ) {
                    $location.url($scope.grievanceFormUrl.replace('/#', ''));
                } else {
                    $scope.selectStateForm.$setDirty();
                }
            }
        }

        function openLAGrienvencesLink() {
            window.open(environment.blobStorageTopUrl + '/grievanceform/SDF-Greivance-Form-Louisianna.pdf');
        }

        function openLink(url) {
            if (!siteContent.site.pages.support.sections.stateSelection.show) {
                window.open(url);
            } else {
                if (
                    $rootScope.supportedStates.length <= 1 ||
                    (!$scope.selectStateForm.$invalid && $scope.selectStateForm.$dirty)
                ) {
                    window.open(url);
                } else {
                    $scope.selectStateForm.$setDirty();
                }
            }
        }

        function updateDocumentLinks(state) {
            $scope.selectedState = state.abbr;
            $scope.showStatedBased = false;
            $scope.statedBasedLinks = [];
            $scope.isCareingtonState = false;
            if (!state) {
                return;
            }

            for (let i = 0; i < $scope.siteContent.careingtonStates.length; i++) {
                const careState = $scope.siteContent.careingtonStates[i];
                if (careState === state.value) {
                    $scope.isCareingtonState = true;
                }
            }

            $scope.grievanceFormUrl = siteContent.site.pages.support.sections.agreements.links.gfLink.link.replace(
                '[[STATE]]',
                state.abbr
            );
            //CHECK IF THERE IS STATE BASED
            if (
                $scope.content.sections.agreements.links.stateBased &&
                $scope.content.sections.agreements.links.stateBased[state.value]
            ) {
                $scope.showStatedBased = true;
                $scope.statedBasedLinks = [];

                var stateValues = $scope.content.sections.agreements.links.stateBased[state.value];

                var exp = new Date();
                exp.setFullYear(exp.getFullYear() + 100);

                $cookies.put('stateValue', state.value, { expires: exp });

                var dataQa = '';
                for (var i = 0; i < stateValues.MA.length; i++) {
                    // this is to stop the 2022 links from showing..
                    if (state.name === 'Florida' && i === 2) {
                        break;
                    }
                    if (stateValues.MA[i].text) {
                        dataQa = 'support.agreements.ma_' + i.toString() + '.link';
                        $scope.statedBasedLinks.push({
                            'text': stateValues.MA[i].text,
                            'url': eval(stateValues.MA[i].link).replace('[[STATE]]', state.value),
                            'dataQa': dataQa
                        });
                    }

                    if (stateValues.FS[i].text) {
                        dataQa = 'support.agreements.fs_' + i.toString() + '.link';
                        $scope.statedBasedLinks.push({
                            'text': stateValues.FS[i].text,
                            'url': eval(stateValues.FS[i].link).replace('[[STATE]]', state.value),
                            'dataQa': dataQa
                        });
                    }
                }
            } else {
                if (
                    $scope.content.sections.agreements.links.pfsLink.link &&
                    $scope.content.sections.agreements.links.pfsLink.link != ''
                ) {
                    $scope.newFeeScheduleUrl = eval($scope.content.sections.agreements.links.pfsLink.link).replace(
                        '[[STATE]]',
                        state.value
                    );
                }

                if ($scope.isCareingtonState) {
                    $scope.dsdUrl =
                        environment.blobStorageTopUrl +
                        '/servicesanddisclosures/DOS_DF_' +
                        $scope.siteContent.planNameShort +
                        '_' +
                        state.value +
                        '.pdf';
                } else {
                    $scope.dsdUrl =
                        environment.blobStorageTopUrl +
                        '/servicesanddisclosures/DOS_DF_' +
                        $scope.siteContent.planNameShort +
                        '_Wellfit.pdf';

                    $scope.laUrl =
                        environment.blobStorageTopUrl +
                        '/servicesanddisclosures/DOS_DF_' +
                        $scope.siteContent.planNameShort +
                        '_Wellfit.pdf';
                }
            }
        }
    }
})(angular);
